import React from 'react'
import { object, bool, func } from 'prop-types'
import { Flex } from 'rebass'
import { trackEvent } from '../../../lib/tracker'
import {
  CtrlFlexWrapper,
  ModalSection,
  ModalSelectItem,
  Info,
  ArrowRight
} from './components/ModalSectionStyled'

class ContentModalCtrl extends React.PureComponent {
  constructor(props) {
    super(props)
    this._handleToggle = this._handleToggle.bind(this)
    this.state = {
      sections: props.sections,
      ...this.getSectionState(props.sections)
    }
  }

  getSectionState(sections) {
    const sectionStates = sections.reduce(
      (sectionStates, section) => ({
        ...sectionStates,
        [`${section.default}`]: !!section.isOpen
      }),
      {}
    )

    const isFocused = Object.values(sectionStates).includes(true)
    return {
      ...sectionStates,
      isFocused
    }
  }

  _handleToggle(section) {
    trackEvent('Modal', 'Option', section.default)
    this.setState((prevState) => {
      const newState = !prevState[`${section.default}`]
      if (section.onOpen && newState === true) {
        section.onOpen()
      } else if (section.onClose) {
        section.onClose()
      }

      return {
        [`${section.default}`]: newState,
        isFocused: !prevState.isFocused
      }
    })
  }

  render() {
    return (
      <CtrlFlexWrapper
        wrap
        width={'100%'}
        className={this.state.isFocused ? 'focused' : ''}
      >
        {this.state.sections.map((_section) => {
          return (
            <ContentModalSection
              title={_section}
              key={`cmods:${_section.default}`}
              togglefn={this._handleToggle}
              open={!!this.state[`${_section.default}`]}
              info={!!_section.info}
              onOpen={_section.onOpen}
              onClose={_section.onClose}
            >
              {_section.content}
            </ContentModalSection>
          )
        })}
      </CtrlFlexWrapper>
    )
  }
}

class ContentModalSection extends React.PureComponent {
  constructor(props) {
    super(props)
    this._handleClose = this._handleClose.bind(this)
    this._handleOpen = this._handleOpen.bind(this)
    this._handleToggle = this._handleToggle.bind(this)
    this._handleKeyPressed = this._handleKeyPressed.bind(this)
    this._isWindowAvailable = typeof window !== 'undefined'
    this.state = {
      isOpen: props.open
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.open })
  }

  _handleKeyPressed(_e) {
    if (!_e.keyCode || _e.keyCode === 27) {
      this._handleClose()
    }
  }

  _handleOpen(_e) {
    if (_e) _e.preventDefault()
    this.setState({ isOpen: true })
  }

  _handleClose(_e) {
    if (_e) _e.preventDefault()
    this.setState({ isOpen: false })
  }

  _handleToggle(_e) {
    if (_e) _e.preventDefault()

    if (this.props.togglefn) {
      this.props.togglefn(this.props.title)
    } else {
      if (this.state.isOpen) {
        this._handleClose()
      } else {
        this._handleOpen()
      }
    }
  }

  render() {
    return (
      <Flex
        wrap
        width={'100%'}
        className={this.state.isOpen ? 'item focused' : 'item'}
      >
        <ModalSelectItem
          width={'100%'}
          py={20}
          px={'7%'}
          onClick={this._handleToggle}
          open={this.state.isOpen}
        >
          {this.props.info && <Info />}
          {!this.state.isOpen && (
            <span>
              {this.props.title.default} <ArrowRight open={this.state.isOpen} />
            </span>
          )}
          {this.state.isOpen && (
            <span>
              <ArrowRight open={this.state.isOpen} /> {this.props.title.active}
            </span>
          )}
        </ModalSelectItem>
        {this.state.isOpen && (
          <ModalSection width={'100%'} py={20} px={'7%'}>
            {this.props.children}
          </ModalSection>
        )}
      </Flex>
    )
  }
}

ContentModalSection.defaultProps = {
  title: { defaultText: '', active: '' },
  focused: false,
  info: false,
  onOpen: null,
  onClose: null
}
ContentModalSection.propTypes = {
  title: object,
  focused: bool,
  info: bool,
  onOpen: func,
  onClose: func
}

export default ContentModalSection
export { ContentModalCtrl }
